// extracted by mini-css-extract-plugin
export default {"activeItem":"Suggestion_activeItem__dvwal","item":"Suggestion_item__T9XXI"};